import callAPiBase from './base';

const dbdsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/dbdList',
      method: 'GET',
      useToken: true,
      title: 'Dbd - Get List',
      params,
    }),

  monitoring: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/dbdMonitoring',
      method: 'GET',
      useToken: true,
      title: 'Dbd - Monitoring',
      params,
    }),

  dbdTelemetry: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/dbdTelemetry',
      method: 'GET',
      useToken: true,
      title: 'Dbd - Telemetry',
      params,
    }),

  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/dbdCreate',
      method: 'POST',
      useToken: true,
      title: 'Dbd - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/dbdUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Dbd - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/dbdDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Dbd - Delete',
      params,
    }),
  dbdVersionRequest: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/dbdVersionRequestList',
      method: 'GET',
      useToken: true,
      title: 'Dbd - Version Request',
      params,
    }),
  requestStatus: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/dbdStatus',
      method: 'POST',
      useToken: true,
      title: 'Dbd - Request Status',
      data,
    }),
  versionList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/dbdVersionList',
      method: 'GET',
      useToken: true,
      title: 'Dbd - Get Version List',
      params,
    }),
  versionUpdateRequest: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/dbdVersionUpdateRequest',
      method: 'POST',
      useToken: true,
      title: 'Dbd - Version Update Request',
      data,
    }),
  createMany: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/dbdCreateList',
      method: 'POST',
      useToken: true,
      title: 'Dbd - Create Many',
      data,
    }),
};

export { dbdsApi };
export default dbdsApi;
